<template>
    <div>
        <nav-breadcrumb :menu="[{label: '债转审核查询'}]"/>

        <el-tabs v-model="status">
            <el-tab-pane label="待审核" name="Pending Approval" />
            <!-- <el-tab-pane label="审核通过" name="Approved" />-->
            <el-tab-pane label="已审核" name="Approved,Rejected,YZZ,CLWC,SSZ" />
        </el-tabs>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import {formatMoney} from "../../filters/CommonFilters";
    import moment from 'moment'
    export default {
        name: "ApproveEquitySwapTxViewList",
        data(){
            return{
                status: 'Pending Approval',
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '债转编号',
                        field: 't__transactionNo'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        label: '客户名称',
                        field: 'ba__customerName',

                    },
                    /*{
                        label: '手机号',
                        field: 'ba__customerContactNo',

                    },*/
                    {
                        label: '受让人',
                        field: 'pto__partnerName'
                    },
                    {
                        label: '债转金额',
                        field: 't__netEquityValue',
                        formatter: function (r,c,v) {
                            return formatMoney(v)
                        },
                    },
                    {
                        label: '债转日期',
                        field: 't__transactionDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '状态',
                        field: 't__transactionStatus',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'view',
                                            query: {
                                                transactionId: row.t__transactionId
                                            }
                                        }
                                    )
                                },
                            },
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                dealerTypeOptions:[],
                page: 1,
                pageSize: 20,
                actions: [
                    /*{
                        label: '导出',
                        clickHandler:()=>{
                            let routeData = this.$router.resolve({
                                path: '/ix/fang/misc/EquitySwapTx.List?format=xls',
                                query: Object.assign(
                                    {
                                        pageSize:0,
                                        'xlist.sort.dataField': 't.netEquityValue',
                                        'xlist.sort.order': 'desc'

                                    }, {}, xmlBuildQuery(this.filters))
                            });
                            window.open(routeData.href.replace('#/', '/'), '_blank');
                        }
                    }*/
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        t__transactionNo:'',
                        ba__customerName:'',
                        fi__transactionNo:'',
                        pto__partnerId:'',
                        t__transactionStatus:''
                    },
                    columns: [

                        {
                            label: '债转编号',
                            component: 'el-input',
                            field: 't__transactionNo',
                            span:8
                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'ba__customerName',
                            span:8
                        },
                       /* {
                            label: '手机号',
                            component: 'el-input',
                            field: 'ba__customerContactNo',
                            span:8
                        },*/
                        {
                            label: '贷款编号',
                            component: 'el-input',
                            field: 'fi__transactionNo',
                            span:8
                        },
                        {
                            label: '受让人',
                            component: 'el-select',
                            field: 'pto__partnerId',
                            options:[],
                            span:8
                        },
                        {
                            label: '状态',
                            component: 'el-select',
                            field: 't__transactionStatus',
                            options: [
                                {
                                    label:'待审核',
                                    value:'Pending Approval'
                                },
                                {
                                    label:'审核不通过',
                                    value:'Rejected'
                                },
                                {
                                    label:'已债转',
                                    value:'YZZ'
                                },
                                {
                                    label:'已清收',
                                    value:'CLWC'
                                },
                                {
                                    label:'诉讼中',
                                    value:'SSZ'
                                }
                            ],
                            span:8
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
            this.getPartnerOptions()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    'xlist.sort.dataField': 't.transactionDate',
                    'xlist.sort.order': 'desc',
                    'xlist.search.t.transactionStatus' : this.status,
                    'xlist.search.t.transactionStatus.op' : 'in',
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {

            getPartnerOptions: function () {
                xhr.getPartnerOptions(
                    Object.assign({
                        'partnerType':'SRR'
                    }, {}, {}),
                    res=> {
                        try {
                            this.filters.columns[3].options = res.data.data.filter(items=>{return items.p__partnerType=='SRR' }).map(item=>{
                                return {
                                    label: item.p__partnerName,
                                    value:item.p__partnerId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            getData: function () {
                xhr.getEquitySwapTxList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },
            removeItem: function (index, row) {
                removeItem(
                    xhr.updateEquitySwapTx,
                    {
                        't.transactionId': row.t__transactionId,
                        't.transactionStatus':'SC',
                        't__checked':true
                    },
                    res=>{
                        try {
                            if(res.data.status == 'success') {
                                this.getData()
                            }
                        }catch (e) {

                        }
                    }

                )
            },

            exportPdf: function (index, row) {
                try {


                    window.open('/extended/markup/t/docs/financing/ZRXY.pdf?t.transactionId='+row.t__transactionId)

                }
                catch (e) {

                }
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApproveEquitySwapTxViewList.vue